import * as swcHelpers from '@swc/helpers';
import '@grandvisionhq/utils';
import { getOfferings } from '../utils/get-offerings.js';
import '@grandvisionhq/graphql';
import '../../../types/product.js';
import { mapServerToFrameVariant } from '../variant-mappers/map-server-to-frame-variant.js';
import { mapServerToProductBase } from './map-server-to-product-base.js';

const mapServerToFramesProduct = (serverProduct, slug, locale, facetConfigList)=>{
    if ((serverProduct === null || serverProduct === void 0 ? void 0 : serverProduct.__typename) !== 'FrameProduct') {
        return {
            failure: 'incorrect-typename',
            message: `Expected FrameProduct for slug "${slug}", but got ${serverProduct === null || serverProduct === void 0 ? void 0 : serverProduct.__typename}`
        };
    }
    const variants = mapServerToFrameVariant(serverProduct, slug, locale);
    if (!variants || variants.length === 0) {
        return {
            failure: 'no-variants',
            message: `Cannot return Frames product with slug: "${slug}" because it has no variants`
        };
    }
    var _lensExtras, _lensDetails, _isExclusiveBrand;
    return swcHelpers.objectSpread({}, mapServerToProductBase(serverProduct, variants, facetConfigList), {
        productType: 'Frames',
        variants,
        offerings: getOfferings(serverProduct.productTypeDetails.offerings, locale),
        isOfferedWithPrescriptions: !!serverProduct.productTypeDetails.isOfferedWithPrescriptions,
        lensExtra: (_lensExtras = serverProduct.productTypeDetails.lensExtras) !== null && _lensExtras !== void 0 ? _lensExtras : undefined,
        lensDetails: (_lensDetails = serverProduct.productTypeDetails.lensDetails) !== null && _lensDetails !== void 0 ? _lensDetails : undefined,
        isExclusiveBrand: (_isExclusiveBrand = serverProduct.productTypeDetails.isExclusiveBrand) !== null && _isExclusiveBrand !== void 0 ? _isExclusiveBrand : undefined
    });
};

export { mapServerToFramesProduct };
//# sourceMappingURL=map-server-to-frame-product.js.map
